import { useSyncExternalStore } from 'react';

import { resolveDateFormat, subscribe } from '@core/format/datePreference';

/**
 * Subscribes to the format in force.
 *
 * <p>
 * `App` calls this, and that one call is what makes a change repaint the whole tree. A screen that
 * merely wants to *render* a date does not need it — `formatDate` reads the same value — but a
 * control that displays the current choice does, or it goes on showing the old one after changing it.
 * </p>
 *
 * <p>
 * The store itself is in the shared core so the mobile app reads the same preference; only this
 * React binding is the web's.
 * </p>
 */
export function useDateFormat(): string {
  // The same function for both snapshots: there is no server render here, and the value is a module
  // variable that is stable between notifications, which is what useSyncExternalStore requires.
  return useSyncExternalStore(subscribe, resolveDateFormat, resolveDateFormat);
}
